export default "__VITE_ASSET__BbGL6cbc__"